import { AxiosService } from './axios.service'

const baseURL = 'preco-da-viagem'

export class CalculationsService {
	/**
	 * Get the calculated values
	 * @return {Promise<any>} The list of origins
	 */
	static getCalculatedValues(data) {
		return AxiosService.post(`${baseURL}/compute-price`, data).then(
			({ data }) => data
		)
	}
}
